// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1__AL","cls2":"AccountMenuButton-cls2_rRF AccountMenuButton-cls1__AL"};